import type PriceSubmissionBlockOutput from '@app/model/pricing-automation/output/PriceSubmissionBlockOutput';

export type GraphQLDouble = number | string;

export const isProviderPriceBlock = (errorCode: string): boolean =>
	errorCode === 'server.exception.pricing_architecture.DISCREPANCY_BETWEEN_LATEST_ROOM_PRICE_AND_RECORDED_PRICE';

export const parseGraphQLDouble = (value: GraphQLDouble): number => {
	const parsedValue = Number(value);
	return Number.isFinite(parsedValue) ? parsedValue : 0;
};

export const formatPercentage = (value: GraphQLDouble): string => {
	const percentage = parseGraphQLDouble(value);
	return `${percentage >= 0 ? '+' : ''}${percentage.toFixed(1)}%`;
};

export const formatProviderPriceBlock = (item: PriceSubmissionBlockOutput, formatAmount: (amount: number) => string): string => {
	const latestProviderPrice = item.latestProviderPrice == null ? NaN : Number(item.latestProviderPrice);
	return `Your PMS price is ${Number.isFinite(latestProviderPrice) ? formatAmount(latestProviderPrice) : 'unavailable'}, RoomPulse recorded `
		+ `${formatAmount(parseGraphQLDouble(item.currentPrice))} `
		+ `(${formatPercentage(item.differencePercentage)}; tolerance ±${parseGraphQLDouble(item.limitPercentage).toFixed(1)}%).`;
};
